(() => {
  window.GrovaSections.register('campaign-digestion-slider', '.section-campaign-digestion-hero [data-gwrh]', (root, scope) => {
    const slider = root.querySelector('[data-gwrh-slider]');
    const track = root.querySelector('[data-gwrh-track]');
    const dots = [...root.querySelectorAll('.gwrh__dot')];
    const slides = [...root.querySelectorAll('[data-gwrh-slide]')];
    if (!slider || !track || slides.length < 2) return;
    let index = 0;
    let startX = 0;
    let currentX = 0;
    let dragging = false;
    const goTo = (nextIndex) => {
      index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    dots.forEach((dot, dotIndex) => scope.on(dot, 'click', () => goTo(dotIndex)));
    scope.on(slider, 'pointerdown', (event) => {
      if (event.target.closest('button, a')) return;
      dragging = true;
      startX = event.clientX;
      currentX = startX;
      track.style.transition = 'none';
      slider.setPointerCapture(event.pointerId);
    });
    scope.on(slider, 'pointermove', (event) => {
      if (!dragging) return;
      currentX = event.clientX;
      track.style.transform = `translateX(calc(-${index * 100}% + ${currentX - startX}px))`;
    });
    scope.on(slider, 'pointerup', () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      const difference = currentX - startX;
      if (difference < -45) goTo(index + 1);
      else if (difference > 45) goTo(index - 1);
      else goTo(index);
    });
    scope.on(slider, 'pointercancel', () => { dragging = false; track.style.transition = ''; goTo(index); });
  });
})();
